import { render, staticRenderFns } from "./CargandoExamen.vue?vue&type=template&id=58ecd564&"
import script from "./CargandoExamen.vue?vue&type=script&lang=js&"
export * from "./CargandoExamen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports